import { Job, OrganizationProfile } from '~/jobiqo/types/types';
import { Dimensions } from '~/jobiqo/lib/analytics';
import { User } from '~/jobiqo/models/user';
import { concatArrayItems } from '~/jobiqo/utils/mapper';

/**
 * Returns the custom dimensions for a given job.
 *
 * Can be used to add custom dimensions to the analytics event for a job.
 *
 * @param {Job} job
 *  The job to return dimensions for.
 * @param {User} user
 *  The current user.
 * @returns {Dimensions}
 *  The custom dimensions object for this job.
 */
export const getCustomJobDimensions = (
  job: Job,
  user: User | null = null,
): Dimensions => {
  const externalType =
    job?.applicationWorkflow === 'external'
      ? job?.applicationLink?.startsWith('mailto:')
        ? 'email'
        : 'external_portal'
      : undefined;
  return {
    publishedAt: job?.published,
    expirationDate: job?.expiration,
    remoteOptions: concatArrayItems(job?.remoteOptions, 'label'),
    workExperience: concatArrayItems(job?.yearsOfExperience, 'label'),
    externalType: externalType,
    entityCustomSubtype: job?.type,
  };
};

/**
 * Returns the custom dimensions for a given organization profile.
 *
 * Can be used to add custom dimensions to the analytics event for an organization profile.
 *
 * @param {OrganizationProfile} organizationProfile
 *  The organization profile to return dimensions for.
 * @returns {Dimensions}
 *  The custom dimensions object for this organization profile.
 */
export const getCustomOrganizationProfileDimensions = (
  organizationProfile: OrganizationProfile,
): Dimensions => {
  return {};
};
